export default {
  tournifyURL: "https://www.tournify.be"
};
